import { Body as body } from './body'
import { Content as content } from './content'
import { Counter as counter } from './counter'
import { Delivery as delivery } from './delivery'
import { Discount as discount } from './discount'
import { Footer as footer } from './footer'
import { FooterRight as footerRight } from './footerRight'
import { Header as header } from './header'
import { HeaderContainer as headerContainer } from './headerContainer'
import { Image as image } from './image'
import { Inline as inline } from './inline'
import { PickupInStore as pickupInStore } from './pickupInStore'
import { PriceFrom as priceFrom } from './priceFrom'
import { PriceTo as priceTo } from './priceTo'
import { Root as root } from './root'
import { Subtitle as subtitle } from './subtitle'
import { Title as title } from './title'
import { TrashCan as trashCan } from './trashCan'

export const Product = {
  body,
  content,
  counter,
  delivery,
  discount,
  footer,
  footerRight,
  header,
  headerContainer,
  image,
  inline,
  pickupInStore,
  priceFrom,
  priceTo,
  root,
  subtitle,
  title,
  trashCan
}
